const resources = {
    representative: 'Des représentants ou des conseillers ou conseillères beauté sont disponibles :',
    monSunTime: 'de 5 h à 21 h HP',
    monSun: 'Du lundi au dimanche',
    chatWithUs: 'Clavardez avec nous'
};

module.exports = function getResource(label) {
    return resources[label];
};
